import React from "react";
import MetricsListItem from "./MetricsListItem";

export default function MetricsList({ assignmentMetrics, onDueDateUpdated }) {
  return (
    <div id="List">
      {assignmentMetrics.length ? (
        <table className="qms-training-table">
          <thead>
            <tr className="qms-training-table-head">
              <th>User</th>
              <th>Group</th>
              <th>Title</th>
              <th>Ver.</th>
              <th>Published</th>
              <th>Assigned</th>
              <th>Due</th>
              <th>Completed</th>
              <th>Status</th>
              <th>Cert.</th>
            </tr>
          </thead>
          <tbody>
            {assignmentMetrics.map((assignmentMetric, index) => {
              return (
                <MetricsListItem
                  key={index}
                  assignmentMetric={assignmentMetric}
                  onDueDateUpdated={onDueDateUpdated}
                />
              );
            })}
          </tbody>
        </table>
      ) : (
        <h5>There are no assignments that match the search term.</h5>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/AssignmentMetricsContainer/MetricsList.js